import BulkCloseModal from './bulk-close-modal.connect'

export default BulkCloseModal
